<template>
  <div class="banner-body">
    <div class="banner">
      <img class="img" src="/images/judicialService/banner-img.png">
      <div class="text-box">
        <h1 class="title">解决文件签署后纠纷，服务电子签署最后一公里</h1>
        <p class="desc">君子签，创新“区块链+司法+电子签署”模式，签署信息同步存证至司法机构，真正实现“即签”、“即存证 ”、“即公证”、“即仲裁”、“即变现”，解决文件签署后纠纷，服务电子签署最后一公里。</p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "banner",
        data() {
          return{

          }
        },
        created() {
        },
        methods: {

        }
    }
</script>

<style scoped lang="less">
  .banner-body{
    width: 100%;
    height: 450px;
    margin-top: -60px;
    min-width: 1200px;
    background: url('/images/judicialService/banner.png') no-repeat center center;
    background-size: cover;
    position: relative;
  }
  .banner{
    width: 1200px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding: 60px 0 0 40px;
    box-sizing: border-box;
    .img{
      width: 487px;
      height: auto;
      flex: 0 0 487px;
      display: block;
    }
    .text-box{
      flex: 1;
      box-sizing: border-box;
      padding-left: 83px;
      padding-right: 32px;
    }
    .title{
      font-size: 26px;
      font-family: HuXiaoBo-NanShen;
      font-weight: 400;
      line-height: 28px;
      padding-bottom: 30px;
      color: #FFFFFF;
    }
    .desc{
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 40px;
      color: #FFFFFF;
      text-align: justify;
    }
  }
</style>



// WEBPACK FOOTER //
// components/judicialService/banner.vue